import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import payment from "./modules/payment";

Vue.use(Vuex, VueAxios, axios);

const URL_V1 = process.env.VUE_APP_API_URL;

let abstractApi = axios.create({
    headers: {
        'locale': 'de',
        'x-api-key': localStorage.getItem('x-api-key')
    }
});

let authServerApi = axios.create({
    headers: {'x-api-key': localStorage.getItem('x-api-key')}
});

const rawAuthor = {
    "firstname": "",
    "lastname": "",
};

export default new Vuex.Store({
    modules: {payment},
    state: {
        abstract: [],
        abstracts: [],
        affiliations: [],
        author: [],
        author_institute: [],
        author_role: [],
        authors: [],
        countries: [],
        datahelper: {},
        gender: [],
        institute: [],
        institutes: [],
        used_institutes: [],
        language: 'de',
        login: {'success': false},
        pages: [],
        processing: {
            'author': false,
            'institute': false,
            'dynamicdata': false,
            'rulex': false,
            'validation': false,
            'pdf': false
        },
        salutation: {},
        settings: {},
        status: [],
        submission_abstracts: {},
        submissions: [],
        theme_list: [],
        themes: [],
        types: [],
        user: {},
        validation: {"is_checked": false, "status": false, "errors": {}},
        authorvalidation: {"is_checked": false, "status": false, "errors": []},
        wording: [],
        rulexvalue: 0,
        cache: {'abstract_id': null, 'submission_id': null},
        mode: {'confirm': false}
    },
    actions: {
        GET_ABSTRACTS: function ({commit, state, dispatch}, submission_id) {
            abstractApi.get(URL_V1 + '/overview/' + submission_id,).then((response) => {
                commit('SET_SUBMISSION_ABSTRACTS', {abstracts: response.data, submission_id: submission_id})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_AUTHORS: function ({commit}, id) {
            abstractApi.get(URL_V1 + '/abstract/' + id + '/authors',).then((response) => {
                commit('SET_AUTHORS', {authors: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_AUTHORS_RESPONSE: function ({commit}, id) {
            return abstractApi.get(URL_V1 + '/abstract/' + id + '/authors',)
        },
        GET_INSTITUTES_RESPONSE: function ({commit}, id) {
            return abstractApi.get(URL_V1 + '/institute/find?filter[author_id]=' + id + '&order=order&sort=asc',)
        },
        GET_INSTITUTES: function ({commit}, id) {
            abstractApi.get(URL_V1 + '/institute/find?filter[author_id]=' + id + '&order=order&sort=asc',).then((response) => {
                commit('SET_INSTITUTES', {institutes: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_AFFILIATIONS: function ({commit}, id) {
            abstractApi.get(URL_V1 + '/abstract/' + id + '/affiliations',).then((response) => {
                commit('SET_AFFILIATIONS', {affiliations: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_THEMES: function ({commit}) {
            abstractApi.get(URL_V1 + '/theme').then((response) => {
                commit('SET_THEMES', {themes: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_THEME_LIST: function ({commit}, themelist_id) {
            abstractApi.get(URL_V1 + '/theme/list/' + themelist_id).then((response) => {
                commit('SET_THEME_LIST', {theme_list: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ONE_AUTHOR: function ({commit, state, dispatch}, id) {
            commit('SET_AUTHOR', rawAuthor)
            abstractApi.get(URL_V1 + '/author/' + id,).then((response) => {
                dispatch('IMPLODE_ADDITIONAL_AUTHOR_DATA', response.data);
            }, (err) => {
                commit('SET_AUTHOR', rawAuthor)
                // @todo handle this error
            })
        },
        GET_ONE_INSTITUTE: function ({commit, state, dispatch}, id) {
            abstractApi.get(URL_V1 + '/institute/' + id,).then((response) => {
                dispatch('IMPLODE_ADDITIONAL_INSTITUTE_DATA', response.data);
            }, (err) => {
                // commit('SET_AUTH', rawAuthor)
                // @todo handle this error
            })
        },
        GET_USED_INSTITUTES: function ({commit}) {
            abstractApi.get(URL_V1 + '/institute/used',).then((response) => {
                commit('SET_USED_INSTITUTES', {institutes: response.data})
            }, (err) => {
            })
        },
        GET_ONE_ABSTRACT: function ({commit, state, dispatch}, id) {
            commit('SET_ABSTRACT', {});
            return abstractApi.get(URL_V1 + '/abstract/' + id,);
        },
        GET_ALL_STATUS: function ({commit}) {
            abstractApi.get(URL_V1 + '/status').then((response) => {
                commit('SET_STATUS', {status: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_TYPES: function ({commit}) {
            abstractApi.get(URL_V1 + '/type').then((response) => {
                commit('SET_TYPES', {types: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_WORDING: function ({commit}, language) {
            abstractApi.get(URL_V1 + '/wording?language=' + language).then((response) => {
                commit('SET_WORDING', {wording: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_COUNTRIES: function ({commit}) {
            abstractApi.get(URL_V1 + '/country').then((response) => {
                commit('SET_COUNTRIES', {countries: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_SUBMISSIONS: function ({commit}) {
            abstractApi.get(URL_V1 + '/settings/submission').then((response) => {
                commit('SET_SUBMISSIONS', {submissions: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_PAGES: function ({commit}) {
            abstractApi.get(URL_V1 + '/settings/page' + '?order=order&sort=asc').then((response) => {
                commit('SET_PAGES', {pages: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_SALUTATIONS: function ({commit}) {
            abstractApi.get(URL_V1 + '/salutation').then((response) => {
                commit('SET_SALUTATION', {salutation: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_GENDER: function ({commit}) {
            abstractApi.get(URL_V1 + '/gender').then((response) => {
                commit('SET_GENDER', {gender: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_DATAHELPER: function ({commit}) {
            abstractApi.get(URL_V1 + '/datahelper').then((response) => {
                commit('SET_DATAHELPER', {datahelper: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_USERDATA: function ({commit}) {
            return authServerApi.get(process.env.VUE_APP_AUTH_URL + 'api/user')
        },
        PUT_ABSTRACT: (state, id) => {
            let additionalKey = 'content';
            let additionalContent = {};
            let abstract = {};
            Object.assign(abstract, state.getters.abstract);
            let cc = 0;
            for (let itemkey in abstract) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = abstract[itemkey]
                delete abstract[itemkey];
            }
            if (cc > 0) {
                abstract[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/abstract/' + id, abstract,)
        },
        SUBMIT_ABSTRACT: (state, id) => {
            let additionalKey = 'content';
            let additionalContent = {};
            let abstract = {};
            Object.assign(abstract, state.getters.abstract);
            abstract.status_id = 2;
            let cc = 0;
            for (let itemkey in abstract) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = abstract[itemkey]
                delete abstract[itemkey];
            }
            if (cc > 0) {
                abstract[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/abstract/' + id + '/submit', abstract,)
        },
        CONFIRM_ABSTRACT: (state, id) => {
            let additionalKey = 'content';
            let additionalContent = {};
            let abstract = {};
            Object.assign(abstract, state.getters.abstract);
            let cc = 0;
            for (let itemkey in abstract) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = abstract[itemkey]
                delete abstract[itemkey];
            }
            if (cc > 0) {
                abstract[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/abstract/' + id + '/confirm', abstract,)
        },
        RESETTOEDIT_ABSTRACT: (state, id) => {
            return abstractApi.get(URL_V1 + '/abstract/' + id + '/reset2edit',)
        },
        PUT_AUTHOR: ({commit, state, dispatch}, data) => {
            let additionalKey = 'additional_content';
            let additionalContent = {};
            let author = {};
            Object.assign(author, data.template);
            let cc = 0;
            for (let itemkey in author) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = author[itemkey]
                delete author[itemkey];
            }
            if (cc > 0) {
                author[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/author/' + data.id, author)
        },
        PUT_INSTITUTE: (state, data) => {
            let additionalKey = 'additional_content';
            let additionalContent = {};
            let institute = {};
            Object.assign(institute, data.template);
            let cc = 0;
            for (let itemkey in institute) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = institute[itemkey]
                delete institute[itemkey];
            }
            if (cc > 0) {
                institute[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/institute/' + data.id, institute,
            )
        },
        CREATE_ABSTRACT: function ({commit}, template) {
            return abstractApi.post(URL_V1 + '/abstract', template,)
        },
        UPDATE_REFERENCE: function ({commit}, template) {
            // DEPRECATED
            return abstractApi.post(URL_V1 + '/abstract/' + template.abstract_id, {"reference_number": template.reference_number},)
        },
        CREATE_AUTHOR: ({commit, state, dispatch}, data) => {
            let additionalKey = 'additional_content';
            let additionalContent = {};
            let author = {};
            Object.assign(author, data.template);
            let cc = 0;
            for (let itemkey in author) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = author[itemkey]
                delete author[itemkey];
            }
            if (cc > 0) {
                author[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/author', author,)
        },
        CREATE_INSTITUTE: function (state, data) {
            let additionalKey = 'additional_content';
            let additionalContent = {};
            let institute = {};
            Object.assign(institute, data.template);
            let cc = 0;
            for (let itemkey in institute) {
                if (!itemkey.startsWith(additionalKey + '__')) {
                    continue;
                }
                cc++;
                additionalContent[itemkey.replace(additionalKey + '__', '')] = institute[itemkey]
                delete institute[itemkey];
            }
            if (cc > 0) {
                institute[additionalKey] = additionalContent;
            }
            return abstractApi.post(URL_V1 + '/institute', institute,)
        },
        DELETE_ABSTRACT: (state, data) => {
            abstractApi.delete(URL_V1 + '/abstract/' + data.abstract_id,).then((response) => {
                Vue.noty.success(state.getters.wording[0].notify.delete_success);
                state.dispatch('GET_ABSTRACTS', data.submission_id);
            }).catch((error) => {
                Vue.noty.error(state.getters.wording[0].notify.delete_not_success);
            })
        },
        DELETE_AUTHOR: (state, author) => {
            abstractApi.delete(URL_V1 + '/author/' + author.id,).then((response) => {
                Vue.noty.success(state.getters.wording[0].notify.delete_success);
                state.dispatch('GET_AUTHORS', author.abstract_id);
            }).catch((error) => {
                Vue.noty.error(state.getters.wording[0].notify.delete_not_success);
            })
        },
        DELETE_INSTITUTE: (state, data) => {
            abstractApi.delete(URL_V1 + '/institute/' + data.institute_id,).then((response) => {
                Vue.noty.success(state.getters.wording[0].notify.delete_success);
                state.dispatch('GET_AUTHORS', data.abstract_id);
                state.dispatch('GET_AFFILIATIONS', data.abstract_id);
            }).catch((error) => {
                Vue.noty.error(state.getters.wording[0].notify.delete_not_success);
            })
        },
        IMPLODE_ADDITIONAL_ABSTRACT_DATA: function ({commit, state, dispatch}, data) {
            let additionalKey = 'content';
            if (!Object.keys(data).includes(additionalKey)) {
                commit('SET_ABSTRACT', {abstract: data})
            } else {
                let additionals = data[additionalKey];
                delete data[additionalKey];
                for (let itemkey in additionals) {
                    data[additionalKey + '__' + itemkey] = additionals[itemkey];
                }
                commit('SET_ABSTRACT', {abstract: data})
            }
        },
        IMPLODE_ADDITIONAL_AUTHOR_DATA: function ({commit, state, dispatch}, data) {
            let additionalKey = 'additional_content';
            if (!Object.keys(data).includes(additionalKey)) {
                commit('SET_AUTHOR', {author: data})
            } else {
                let additionals = data[additionalKey];
                delete data[additionalKey];
                for (let itemkey in additionals) {
                    data[additionalKey + '__' + itemkey] = additionals[itemkey];
                }
                commit('SET_AUTHOR', {author: data})
            }
        },
        IMPLODE_ADDITIONAL_INSTITUTE_DATA: function ({commit, state, dispatch}, data) {
            let additionalKey = 'additional_content';
            if (!Object.keys(data).includes(additionalKey)) {
                commit('SET_INSTITUTE', {institute: data})
            } else {
                let additionals = data[additionalKey];
                delete data[additionalKey];
                for (let itemkey in additionals) {
                    data[additionalKey + '__' + itemkey] = additionals[itemkey];
                }
                commit('SET_INSTITUTE', {institute: data})
            }
        },
        VALIDATE: function ({commit, state, dispatch}, data) {
            abstractApi.post(URL_V1 + '/validate', state.abstract
            ).then((response) => {
                let validation = {"is_checked": true, "status": true, "errors": {}};
                commit('SET_VALIDATION', {validation: validation});
            }).catch((error) => {
                let validation = {"is_checked": true, "status": false, "errors": error.response.data};
                commit('SET_VALIDATION', {validation: validation});
            })
        },
        VALIDATE_TARGET: function ({commit, state, dispatch}, data) {
            return abstractApi.post(URL_V1 + '/validate/' + data.target, data.template);
        },
        VALIDATE_INTEGRITY_AUTHOR: function ({commit, state, dispatch}, author_id) {
            return abstractApi.get(URL_V1 + '/validate/integrity/author/' + author_id);
        },
        PRESENTER_ABSTRACTS: function ({commit, state, dispatch}, data) {
            return abstractApi.post(URL_V1 + '/author/presenter/abstracts', data.template,);
        },
        CONFIRMATION_DETAILS: function ({commit, state, dispatch}, id) {
            return abstractApi.get(URL_V1 + '/confirmation/details/abstract/' + id,);
        },
        logout: (state, data) => {
            localStorage.removeItem('x-api-key');
        },
        GET_PDF: function ({commit, state}, abstract_id) {
            state.processing.pdf = true;
            abstractApi.post(URL_V1 + '/manager/export/pdf/filter/dynamic/template/submission_submit/system/submission/action/export', {
                "filtergroups": [
                    {
                        "logic": "where",
                        "active": true,
                        "objects": [
                            {
                                "type": "array",
                                "group": "abstract",
                                "logic": "where",
                                "active": true,
                                "filter": "id",
                                "search": abstract_id,
                                "btnlabel": "Abstract Id",
                                "operator": "="
                            }
                        ]
                    }
                ],
                "selectfields": [
                    "abstract.id",
                    "abstract.type_id",
                    "abstract.theme_id",
                    "abstract.title",
                    "abstract.status_id",
                    "abstract.user_id"
                ],
                "filtersort": [
                    {
                        "group": "abstract",
                        "filter": "id",
                        "sort": "asc"
                    }
                ]
            }, {responseType: "blob"}).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Abstract_" + abstract_id + ".pdf");
                document.body.appendChild(link);
                state.processing.pdf = false;
                link.click();
            }).catch(() => {
                state.processing.pdf = false;
                Vue.noty.error("PDF could not be generated.");
            });
        },
    },
    mutations: {
        SET_ABSTRACTS: (state, {abstracts}) => {
            state.abstracts = abstracts
        },
        SET_SUBMISSION_ABSTRACTS: (state, {abstracts, submission_id}) => {
            Vue.set(state.submission_abstracts, submission_id, abstracts)
            // state.submission_abstracts[submission_id] = abstracts;
        },
        SET_ABSTRACT: (state, {abstract}) => {
            state.abstract = abstract
        },
        SET_STATUS: (state, {status}) => {
            state.status = status
        },
        SET_AUTHORS: (state, {authors}) => {
            state.authors = authors
        },
        SET_AUTHOR: (state, {author}) => {
            state.author = author
        },
        SET_INSTITUTE: (state, {institute}) => {
            state.institute = institute
        },
        SET_USED_INSTITUTES: (state, {institutes}) => {
            state.used_institutes = institutes
        },
        SET_INSTITUTES: (state, {institutes}) => {
            state.institutes = institutes
        },
        SET_AFFILIATIONS: (state, {affiliations}) => {
            state.affiliations = affiliations
        },
        SET_THEMES: (state, {themes}) => {
            state.themes = themes
        },
        SET_THEME_LIST: (state, {theme_list}) => {
            state.theme_list = theme_list
        },
        SET_TYPES: (state, {types}) => {
            state.types = types
        },
        SET_WORDING: (state, {wording}) => {
            state.wording = wording
        },
        SET_COUNTRIES: (state, {countries}) => {
            state.countries = countries
        },
        SET_SUBMISSIONS: (state, {submissions}) => {
            state.submissions = submissions
        },
        SET_SETTINGS: (state, {settings}) => {
            state.settings = JSON.parse(settings)
        },
        SET_SALUTATION: (state, {salutation}) => {
            state.salutation = salutation
        },
        SET_GENDER: (state, {gender}) => {
            state.gender = gender
        },
        SET_DATAHELPER: (state, {datahelper}) => {
            state.datahelper = datahelper
        },
        SET_PAGES: (state, {pages}) => {
            state.pages = pages
        },
        SET_VALIDATION: (state, {validation}) => {
            state.validation = validation
        },
        SET_RULEXVALUE: (state, {rulex}) => {
            state.rulexvalue = rulex
        },
        SET_AUTHOR_VALIDATION_ERROR: (state, {validation}) => {
            state.authorvalidation = validation;
        },
        SET_USER: (state, {user}) => {
            state.user = user
        },
        SET_TOKEN: (state, {token}) => {
            abstractApi.defaults.headers['x-api-key'] = token;
            authServerApi.defaults.headers['x-api-key'] = token;
        }
    },
    getters: {
        abstract: (state) => {
            return state.abstract
        },
        wording: (state) => {
            return state.wording
        },
        getCurrentPages: (state) => (submission_id) => {
            return state.pages.filter(page => page.setting_submission_id === submission_id)
        },
        getFirstCurrentPage: (state) => (submission_id) => {
            return state.pages.find(page => page.setting_submission_id === submission_id && page.order === 1)
        },
        getCurrentPageById: (state) => (page_id) => {
            return state.pages.find(page => page.id === page_id)
        },
        getCurrentPageByType: (state) => (submission_id, page_type) => {
            return state.pages.find(page => page.setting_submission_id === submission_id && page.setting_page_type_id === page_type)
        },
        getSettings: (state) => (submission_id) => {
            return JSON.parse(state.submissions.find(submission => submission.id === submission_id).settings)
        },
        getConfirmEntities: (state) => (submission_id) => {
            return JSON.parse(state.submissions.find(submission => submission.id === submission_id).confirm_entities)
        },
        getPresenter: (state) => {
            return state.authors.filter(author => author.role_id === 2)
        },
        isOpen: (state) => (submission_id) => {
            return state.submissions.find(submission => submission.id === submission_id).isOpen
        }
    },
})
